import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Grid } from '@hbf/dsl';

import { Props as BillsProps, BillsFilter } from './BillsFilter';
import { Props as PriceProps, PriceFilter } from './PriceFilter';

interface Props {
  bills: BillsProps;
  price: PriceProps;
}

const useStyles = makeStyles()(t => ({
  item: {
    marginBottom: t.spacing(2),
  },
}));

const PriceAndBillsFilter: React.FC<Props> = ({ bills, price }) => {
  const { classes } = useStyles();

  return (
    <Grid container direction="column">
      <Grid item className={classes.item}>
        <PriceFilter
          value={price.value}
          onChange={price.onChange}
          currencyValue={price.currencyValue}
          onCurrencyChange={price.onCurrencyChange}
          priceMin={price.priceMin}
          priceMax={price.priceMax}
          priceDistribution={price.priceDistribution}
        />
      </Grid>
      <Grid item>
        <BillsFilter
          value={bills.value}
          onChange={bills.onChange}
          count={bills.count}
        />
      </Grid>
    </Grid>
  );
};

export { PriceAndBillsFilter };
